import { render, staticRenderFns } from "./Question4.vue?vue&type=template&id=c968b590"
import script from "./Question4.vue?vue&type=script&lang=js"
export * from "./Question4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports